import { render, staticRenderFns } from "./projectAuzSys.vue?vue&type=template&id=ad965a96&scoped=true&"
import script from "./projectAuzSys.vue?vue&type=script&lang=js&"
export * from "./projectAuzSys.vue?vue&type=script&lang=js&"
import style0 from "./projectAuzSys.vue?vue&type=style&index=0&id=ad965a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad965a96",
  null
  
)

export default component.exports